export const subscriptionKeys = {
    userSubscription: 'userSubscription',
    subscritionRequest: 'subscriptionRequest',
}